import React, {useEffect, useState} from 'react'
import {Navigate} from "react-router-dom";
import {useQuery} from "../utils/function-util";
import {sections} from "../layout/sideBar/SectionsList";
import {useCapability} from "../auth/CapabilityContext";
import OrganizationsCardPicker from "../components/organizations/OrganizationsCardPicker";
import {Roles} from "../auth/roles";
import {OrganizationsTablePicker} from "../components/organizations/OrganizationsTablePicker";
import {useOrganization} from "../components/organizations/organization-context";
import {getOrganization} from "../api/organization-functions";
import Loader from "../components/ui/Loader";

function Organizations() {
    const query = useQuery();
    const returnUrl = query.get("returnUrl");
    const organizationId = parseInt(query.get("organizationId") as string) || undefined;
    const [currentOrganization, setOrganization] = useOrganization();
    const [selectedOrganization, setSelectedOrganization] = useState(currentOrganization);
    const {capabilities, hasRole} = useCapability();
    const [redirect, setRedirect] = useState<string|null>(null);
    const [smartRedirect, setSmartRedirect] = useState<boolean>();
    const redirecting = organizationId && returnUrl;

    useEffect(() => {
        if(organizationId && redirecting) {
            void setOrganizationAndRedirect(+organizationId);
        }
    }, [redirecting]);

    useEffect(() => {
        (async () => {
            if(selectedOrganization && selectedOrganization.id && currentOrganization !== selectedOrganization) {
                await setOrganization(selectedOrganization)
                if(returnUrl) setRedirect(returnUrl);
                else setSmartRedirect(true);
            }
        })();
    }, [selectedOrganization, capabilities])

    useEffect(() => {
       if(smartRedirect) {
           const organizationCapabilities = selectedOrganization ? capabilities[selectedOrganization.id] : undefined;
           const destination = sections.find(n =>
               n.showSection(selectedOrganization?.id, organizationCapabilities, hasRole)
               && !n.link.includes('organizations')
           );
           setRedirect(destination?.link || '/organizations');
       }
    }, [smartRedirect, selectedOrganization, capabilities]);

    const onOrganizationSelected = (organization: any) => {
        setSelectedOrganization(organization);
    };

    const setOrganizationAndRedirect = async (organizationIdForRedirect: number) => {
        if(organizationIdForRedirect && organizationIdForRedirect === currentOrganization?.id){
            setRedirect(`${returnUrl || '/organizations'}`);
        } else {

            try {
                setSelectedOrganization(await getOrganization(organizationIdForRedirect));
            }
            catch (err) {
                console.error(err);
            }
        }
    }

    if (redirect)
        return <Navigate to={redirect} replace={false}/>

    if (redirecting)
        return <Loader show />

    return hasRole(Roles.ADMIN) ? <OrganizationsTablePicker
        selected={selectedOrganization}
        onSelect={onOrganizationSelected}
    /> : <OrganizationsCardPicker
        selected={selectedOrganization}
        onSelect={onOrganizationSelected}
    />;
}

export default Organizations
